import React from "react";

import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { Box, Checkbox, FormGroup, Typography } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useDrag } from "react-dnd";
import { makeStyles, withStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

import { ComponentProps, DragType } from "../utils/types";

const useStyles = makeStyles()(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: colors.light,
    width: "100%",
    padding: 8,
    marginBottom: 8,
  },

  header: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
}));

const StyledDragIndicatorIcon = withStyles(DragIndicatorIcon, (theme) => ({
  root: {
    color: colors.gray,
  },
}));

const VerticalMultipleSelector: React.FC<ComponentProps> = ({
  componentType,
}) => {
  const [, drag] = useDrag({
    type: DragType.COMPONENT,
    item: () => {
      return componentType;
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  const { classes } = useStyles();
  const [state, setState] = React.useState({
    checkedA: true,
    checkedB: true,
    checkedC: false,
  });
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  return (
    <div className={classes.root} ref={drag}>
      <Box className={classes.header}>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            variant="h6"
            color="textPrimary"
            style={{ marginBottom: 12 }}
          >
            Vertical Multiple Selector
          </Typography>
          <StyledDragIndicatorIcon />
        </Box>
        <FormGroup row={false}>
          <FormControlLabel
            control={
              <Checkbox
                checked={state.checkedA}
                onChange={handleChange}
                name="checkedA"
                color="primary"
              />
            }
            label="Item 1"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={state.checkedB}
                onChange={handleChange}
                name="checkedB"
                color="primary"
              />
            }
            label="Item 2"
          />
        </FormGroup>
      </Box>
    </div>
  );
};

export default VerticalMultipleSelector;
